import { WebsiteHeaderPhotoSchema_PhotoArch_v1_1_1 } from '@apps/guest/websiteHeader';

export const PHOTO_ARCH_v1_1_1: WebsiteHeaderPhotoSchema_PhotoArch_v1_1_1 = {
  $id: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoArch-v1_1_1.json',
  presentationLayout: 'photoArch',
  photos: [],
};
